var React = require('react');

function HeroVectorRightInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"#484848","strokeWidth":"2","d":"M116 107a390 390 0 0 1 550 0L391 382 116 107Zm665 1058c0 215-174 389-389 390v-391h-1a390 390 0 0 1-1-780v391h1c215 0 390 175 390 390Z"}));
}

HeroVectorRightInline.defaultProps = {"width":"648","height":"1080","fill":"none"};

module.exports = HeroVectorRightInline;

HeroVectorRightInline.default = HeroVectorRightInline;
